import { render, staticRenderFns } from "./PlatformDisplay.vue?vue&type=template&id=4412a288&scoped=true&"
import script from "./PlatformDisplay.vue?vue&type=script&lang=ts&"
export * from "./PlatformDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./PlatformDisplay.vue?vue&type=style&index=0&id=4412a288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412a288",
  null
  
)

export default component.exports